export const GS_TYPE_ATTACHMENT = 'attachment';
export const GS_TYPE_IMAGE = 'image';

export const serializeFileForRender = ({
  id,
  download_url: downloadUrl,
  file_name: fileName,
  mime_type: mimeType,
}) => ({
  id,
  name: fileName,
  url: downloadUrl,
  type: mimeType,
});

export const serializeImageFileForRender = ({
  id,
  file_name: fileName,
  file_url: fileUrl,
  large_url: largeUrl,
  medium_url: mediumUrl,
}) => ({
  id,
  thumbnailUrl: mediumUrl || largeUrl || fileUrl,
  fileUrl: largeUrl || fileUrl,
  fileName,
});

const serializeImagePreview = ({ id, fileUrl, fileName }) => ({
  id,
  default_url: fileUrl,
  name: fileName,
});

export const prepareImagePreviews = (images) =>
  images && images.length ? images.map(serializeImagePreview) : undefined;

export const filterGsImages = (uploads) =>
  uploads?.length
    ? uploads.filter(({ type }) => type === GS_TYPE_IMAGE)
    : undefined;

export const filterGsAttachments = (uploads) =>
  uploads?.length
    ? uploads.filter(({ type }) => type === GS_TYPE_ATTACHMENT)
    : undefined;
